// Mock data for Red Pillar Compliance website

export const companyInfo = {
  name: "RedPillar Compliance",
  tagline: "Transforming Compliance into Confidence",
  description: "Your strategic partner in Financial Services Risk management and Compliance",
  email: "info@redpillar.co.za",
  phone: "+27 72 576 6575",
  address: "South Africa"
};

export const heroContent = {
  title: "Transforming Compliance into Confidence",
  subtitle: "We flip the script on compliance—turning regulatory obligations into strategic advantages for Financial Institutions",
  cta: "Let's Connect",
  stats: [
    { value: "20+", label: "Years of Experience" },
    { value: "Free", label: "Initial Consultation" },
    { value: "24/7", label: "Support Available" }
  ]
};

export const services = [
  {
    id: 1,
    title: "Dedicated Compliance Officer",
    icon: "Shield",
    description: "Your dedicated Compliance Officer managing your full compliance profile, regulator engagement, and strategic guidance.",
    features: [
      "Manage compliance profile and submissions",
      "Guidance on regulatory universe (FSCA, PA, Information Regulator)",
      "Attendance at meetings and regulator engagement",
      "Handle compliance queries and strategic advice"
    ]
  },
  {
    id: 2,
    title: "Risk Management",
    icon: "AlertTriangle",
    description: "Comprehensive risk identification and mitigation with tailored strategies for your institution.",
    features: [
      "Risk identification with tailored risk matrix",
      "Risk Register creation and maintenance",
      "Risk-based approach adoption",
      "Fraud Detection and Red Flag identification"
    ]
  },
  {
    id: 3,
    title: "Compliance Monitoring",
    icon: "Eye",
    description: "Ongoing monitoring to ensure continuous compliance with all legislative requirements.",
    features: [
      "Legislative requirement tracking",
      "Representative Register management",
      "Document review for compliance",
      "Conflict of interest and ethics management"
    ]
  },
  {
    id: 4,
    title: "Mentorship Program",
    icon: "Users",
    description: "Build internal compliance capacity with structured mentorship and guidance.",
    features: [
      "Fit and Proper assessment and application assistance",
      "Ongoing mentoring and training",
      "Capacity building for internal teams",
      "Knowledge transfer and empowerment"
    ]
  },
  {
    id: 5,
    title: "Compliance Succession Planning",
    icon: "BookOpen",
    description: "Build internal compliance capacity with structured succession planning and guidance.",
    features: [
      "Review of current Compliance Succession",
      "Practical Compliance Guidance on Succession Planning",
      "Identification of suitable successors",
      "Knowledge transfer and empowerment"
    ]
  },
  {
    id: 6,
    title: "Additional Services",
    icon: "FileText",
    description: "Comprehensive support including reports and legislative updates.",
    features: [
      "Monthly/quarterly compliance reports",
      "Legislative change summaries with impact analysis",
      "Financial institution application assistance"
    ]
  }
];

export const vision = {
  title: "Our Vision",
  description: "Compliance shouldn't feel like a chore. We're here to transform it into a strategic partner that drives growth, innovation, and peace of mind for Financial Institutions."
};

export const mission = {
  title: "Our Mission",
  description: "To be the trusted compliance partner that Financial Institutions turn to—not just for meeting regulations, but for turning compliance into a competitive advantage."
};

export const values = [
  {
    title: "Transformation",
    description: "We turn compliance burdens into confidence and strategic advantages",
    icon: "Zap"
  },
  {
    title: "Partnership",
    description: "We're not just service providers—we're your strategic partners in success",
    icon: "Handshake"
  },
  {
    title: "Expertise",
    description: "Deep industry knowledge and practical solutions that work",
    icon: "Award"
  },
  {
    title: "Proactivity",
    description: "Identifying and resolving issues before they become problems",
    icon: "Target"
  }
];

export const team = [
  {
    id: 1,
    name: "Chase Muir",
    role: "Compliance Powerhouse",
    image: "https://customer-assets.emergentagent.com/job_7e581e08-03ab-4361-a9a2-08be5db6d298/artifacts/2xugd5cm_Chase%20photo.jpeg",
    bio: "With over 11 years of experience in operational risk management and compliance, Chase brings unmatched expertise to every engagement.",
    expertise: [
      "Operational Risk Management and Compliance Specialist",
      "Seasoned professional in regulator engagement",
      "Approved for CAT I, II, IIA & IV",
      "CISA & IRMSA Member",
      "Practical, scalable compliance solutions"
    ],
    credentials: ["CAT I, II, IIA & IV", "CISA & IRMSA", "11+ Years"]
  },
  {
    id: 2,
    name: "Tinita Gerber",
    role: "Compliance Officer",
    image: "https://customer-assets.emergentagent.com/job_7e581e08-03ab-4361-a9a2-08be5db6d298/artifacts/b99v3l64_Tinita%20Image.jpg",
    bio: "Tinita blends legal expertise with practical compliance know-how, bringing 7 years of corporate legal advisory experience.",
    expertise: [
      "Long-Term Insurance Specialist",
      "Registered Cat I & IV FAIS Compliance Officer",
      "FIC Compliance",
      "POPIA Compliance",
      "Combining Business Landscape with Legal expertise"
    ],
    credentials: ["BCom Law", "7 Years", "Cat I & IV FAIS CO"]
  },
  {
    id: 3,
    name: "Rigert du Toit",
    role: "Compliance Officer",
    image: "https://customer-assets.emergentagent.com/job_7e581e08-03ab-4361-a9a2-08be5db6d298/artifacts/dfswvj9w_Rigert.jpg",
    bio: "With over four years of FAIS-related compliance experience, Rigert develops robust frameworks that strengthen operational integrity. He is also a contract specialist with a keen eye for detail, particularly in regulatory analysis.",
    expertise: [
      "Long-Term Insurance Specialist",
      "Registered Cat I & IV FAIS Compliance Officer",
      "FIC Compliance",
      "Solutions-driven practical approach"
    ],
    credentials: ["LLB Cum Laude", "FAIS Expert", "4+ Years"]
  }
];

export const problemStatement = {
  title: "The Problem with Traditional Compliance",
  issues: [
    {
      icon: "Circle",
      title: "Tick-Box Exercise",
      description: "Compliance treated as a burden rather than a strategic opportunity"
    },
    {
      icon: "Circle",
      title: "Limited Services",
      description: "Generic solutions that don't address unique institutional needs"
    },
    {
      icon: "Circle",
      title: "Reactive Approach",
      description: "Issues discovered too late, leading to costly penalties"
    },
    {
      icon: "Circle",
      title: "Lack of Partnership",
      description: "Transactional relationships without strategic guidance"
    }
  ]
};

export const solution = {
  title: "The RedPillar Difference",
  subtitle: "We flip the script on compliance",
  benefits: [
    {
      icon: "CheckCircle",
      title: "Strategic Partner",
      description: "We work alongside you as a trusted partner, not just a service provider"
    },
    {
      icon: "CheckCircle",
      title: "Tailored Solutions",
      description: "Customised compliance strategies designed for your unique needs"
    },
    {
      icon: "CheckCircle",
      title: "Proactive Prevention",
      description: "Identify and resolve issues before they become costly problems"
    },
    {
      icon: "CheckCircle",
      title: "Growth Enabler",
      description: "Turn compliance into a competitive advantage that drives innovation"
    }
  ]
};

export const callbackReasons = [
  "Request a Consultation",
  "Discuss Compliance Needs",
  "Learn About Services",
  "Schedule a Meeting",
  "General Inquiry"
];

// Mock function to simulate callback request submission
export const submitCallbackRequest = async (data) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("Callback request submitted:", data);
      resolve({ success: true, message: "We'll call you back shortly!" });
    }, 1000);
  });
};

// Mock function to simulate contact form submission
export const submitContactForm = async (data) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("Contact form submitted:", data);
      resolve({ success: true, message: "Thank you for reaching out! We'll respond within 24 hours." });
    }, 1000);
  });
};
